import React from 'react';

type SkeletonProps = {
  className?: string;
  rounded?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | 'full' | 'none';
};

const ROUNDED: Record<NonNullable<SkeletonProps['rounded']>, string> = {
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
  '2xl': 'rounded-2xl',
  '3xl': 'rounded-3xl',
  full: 'rounded-full',
  none: 'rounded-none',
};

/** Shimmer placeholder block — use inside layout shells that mirror real content. */
export function Skeleton({ className = '', rounded = 'lg' }: SkeletonProps) {
  return (
    <div
      className={`skeleton-block ${ROUNDED[rounded]} ${className}`}
      aria-hidden
    />
  );
}

export default Skeleton;
